import Popup from '@/components/Common/DesignSystem/Popup/Popup';
import { NolPromotionStoreCtx } from '@/stores/NolPromotionStore';
import { observer } from 'mobx-react-lite';
import React, { FC, useContext } from 'react';

const LoginConfirmPopup: FC = () => {
  const store = useContext(NolPromotionStoreCtx);
  return (
    <Popup
      isOpen={store.isLoginPopupOpen}
      mainBtn={{
        label: '로그인하기',
        onClick: () => store.waitForLoginPopup?.complete(true),
      }}
      subBtn={{
        label: '닫기',
        onClick: () => store.waitForLoginPopup?.complete(false),
      }}
    >
      {{ title: 'NOL 로그인을 먼저 진행해 주세요' }}
    </Popup>
  );
};

export default observer(LoginConfirmPopup);
